import { trpc } from '@/trpc/client';

export const useCreateBookingAmendmentMutation = () => {
  return trpc.bookingManagement.createBookingAmendment.useMutation();
};
